import { render, staticRenderFns } from "./Contactos.vue?vue&type=template&id=305071c6&"
import script from "./Contactos.vue?vue&type=script&lang=js&"
export * from "./Contactos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports